/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useWindowSize from '../../hooks/useWindowSize';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/story-heading.scss';

const propTypes = {
    item: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const StoryHeading = ({ item, className }) => {
    const size = useWindowSize();
    const ratio = item.video.height / item.video.width;

    let style = {};
    if (ratio && size.width < 790) {
        style = { paddingBottom: `${ratio * 100}%`, height: 0 };
    }

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.videoBackground}>
                <div
                    className={classNames([styles.iframeContainer])}
                    style={style}
                    dangerouslySetInnerHTML={{ __html: item.video.iframe }} // eslint-disable-line
                />
            </div>
            <div className={styles.text}>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.author}>{item.author}</div>
                <div className={styles.date}>{item.date}</div>
            </div>
        </div>
    );
};

StoryHeading.propTypes = propTypes;
StoryHeading.defaultProps = defaultProps;

export default StoryHeading;
